import classNames from 'classnames'
import { Icon } from '@winnin/winnin_ui.components.icon'

import { BlockComponentsRole75Checker } from 'components'
import { useTranslate } from 'lib/tolgee'

import { starIcon } from './favorite.consts'
import { translations } from './favorite.i18n'
import type { IFavoriteView } from './favorite.types'

import './favorite.styles.scss'

export const FavoriteView = ({ isSaved, cantSave, isViewerUser, handleButtonClick, size, loading }: IFavoriteView) => {
  const t = useTranslate()

  return (
    <BlockComponentsRole75Checker
      isClickBlocked={isViewerUser || cantSave}
      blockMessage={cantSave ? t(translations.limitText) : null}
    >
      <button
        onClick={handleButtonClick}
        className={classNames(['FavoriteButton', { 'FavoriteButton--isSaved': isSaved }])}
        disabled={cantSave || loading}
      >
        <Icon
          icon={isSaved ? starIcon[size].active : starIcon[size].inactive}
          fill={isSaved ? 'var(--color_warning_500)' : 'var(--color_neutral_500)'}
        />
      </button>
    </BlockComponentsRole75Checker>
  )
}
